<template>
    <div class="row">
        <or-select
            class="feature-selection"
            v-model="localSelectedEntities"
            :label="$t('model.nlu-model.sidebar.entities.editors.ml-entity.ml-entities-selection.entity')"
            :placeholder="$t('model.nlu-model.sidebar.entities.editors.ml-entity.ml-entities-selection.selectEntity')"
            :options="$props.entities"
            :disabled="isLoading"
            multiple
        />
        <or-select
            v-if="isRequiredSelectable"
            class="feature-selection--required"
            v-model="localRequiredEntity"
            :label="$t('model.nlu-model.sidebar.entities.editors.ml-entity.ml-entities-selection.entityRequired')"
            :placeholder="$t('model.nlu-model.sidebar.entities.editors.ml-entity.ml-entities-selection.selectRequiredEntity')"
            :options="requiredEntitiesOpts"
            :no-results="selectedEntities.length === 0"
            :disabled="isLoading"
        />
    </div>
</template>

<script>
export default {
  name: 'ml-entities-selector',
  props: {
    entities: Array,
    // https://gitlab.com/onereach/platform/nlu/nlu-api/-/blob/feature/1.1832/117/lib/schemas/joi/simple_entity.js
    selectedEntities: Array,
    isLoading: Boolean,
    isRequiredSelectable: Boolean
  },

  computed: {
    requiredEntitiesOpts () {
      return [{
        label: 'None',
        value: '$none'
      }, ...this.selectedEntities.map(entity => ({
        label: entity.modelName,
        value: entity.modelName
      }))]
    },

    localSelectedEntities: {
      get () {
        return this.$props.selectedEntities.map(entity => entity.modelName)
      },
      set (entities) {
        const requiredEntity = this.$props.selectedEntities.find(entity => entity.isRequired)
        const requiredEntityName = requiredEntity ? requiredEntity.modelName : undefined
        const transformedEntities = entities.map(entity => ({
          modelName: entity,
          isRequired: entity === requiredEntityName
        }))
        this.$emit('update:selected-entities', transformedEntities)
      }
    },

    localRequiredEntity: {
      get () {
        const requiredEntity = this.$props.selectedEntities.find(entity => entity.isRequired)
        return requiredEntity ? requiredEntity.modelName : ''
      },
      set (requiredEntity) {
        const transformedEntities = this.$props.selectedEntities.map(entity => ({
          modelName: entity.modelName,
          isRequired: requiredEntity.value !== '$none' && entity.modelName === requiredEntity
        }))
        this.$emit('update:selected-entities', transformedEntities)
      }
    }
  }
}
</script>

<style scoped>

</style>
